import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  CircularProgress,
} from "@mui/material";
// import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import axios from "axios";
// import Sidebar from "../../layouts/core/Sidebar"; 

const CsrReport = () => {
  const [data, setData] = useState([]); // Initialize with an empty array
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [centerCodeFilter, setCenterCodeFilter] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Manage sidebar open/close state

  // Fetch CSR report data from API
  useEffect(() => {
    const examDetails = JSON.parse(localStorage.getItem("examDetails")); 
    const examName = examDetails?.examName;
    const shift = examDetails?.shift;
  
    if (!examName || !shift) return;
  
    setLoading(true);
    axios
      .post("https://croireatpl.in/api/csrReportsByExamAndShift", {
        examName,
        shift,
      })
      .then((response) => {
        const fetchedData = Array.isArray(response.data) ? response.data : [];
        setData(fetchedData);
      })
      .catch((error) => {
        console.error("Error fetching CSR report data:", error);
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CSR Report");
    XLSX.writeFile(wb, "csr_report.xlsx");
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("CSR Report", 14, 16);

    const columns = [
      "S.No",
      "Operator Name",
      "Operator Number",
      "Center Code",
      "Shift",
      "CSR Report",
    ];

    const rows = data.map((row, index) => [
      index + 1,
      row.operatorName,
      row.operatorNumber,
      row.centerCode,
      row.shift,
      "View Report",
    ]);

    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 20,
      theme: "striped",
      margin: { top: 30, left: 14, right: 14 },
    });

    doc.save("csr_report.pdf");
  };

  // Filter data based on center code (optional)
  const filteredData = data.filter((row) =>
    row.centerCode.toLowerCase().includes(centerCodeFilter.toLowerCase())
  );

  return (
    <>
      {/* Sidebar */}
      {/* <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        setShowAnalytics={() => {}}
        setShowCandidateStats={() => {}}
        handleAnalytics={() => {}}
      /> */}

      {/* Main content area */}
      <Box
        sx={{
          margin: 4,
          // flexGrow: 1,
          // padding: 4,
          // transition: "all 0.3s ease", // Smooth transition
          // marginLeft: isSidebarOpen ? "240px" : "0px", // Adjust space based on sidebar state
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
          CSR Report
        </Typography>

        {/* Filter Section */}
        <Box sx={{ mb: 4 }}>
          <input
            type="text"
            value={centerCodeFilter}
            onChange={(e) => setCenterCodeFilter(e.target.value)}
            placeholder="Filter by Center Code"
            style={{ padding: "8px", width: "200px" }}
          />
        </Box>

        {/* Export Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 2,
          }}
        >
          <Button
            variant="contained"
            color="success"
            startIcon={<DescriptionIcon />}
            onClick={handleExportExcel}
          >
            Export to Excel
          </Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<PictureAsPdfIcon />}
            onClick={handleExportPDF}
          >
            Export to PDF
          </Button>
        </Box>

        {/* Loading State */}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", padding: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper} sx={{ mt: 4 }}>
            <Table sx={{ minWidth: 650 }} aria-label="csr report table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    S.No
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    Operator Name
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    Operator Number
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    Center Code
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    Shift
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    Total Students
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    Absent Students
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    Present Students
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#1976d2", color: "white" }}>
                    CSR Report
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={row.operatorNumber}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.operatorName}</TableCell>
                      <TableCell>{row.operatorNumber}</TableCell>
                      <TableCell>{row.centerCode}</TableCell>
                      <TableCell>{row.shift}</TableCell>
                      <TableCell>{row.totalStudent}</TableCell>
                      <TableCell>{row.absentStudents}</TableCell>
                      <TableCell>{row.presentStudent}</TableCell>
                      <TableCell>
                        <a
                          href={row.csrReport}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Report
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </Box>
    </>
  );
};

export default CsrReport;
